/* Core & libraries */
import React, { useEffect } from "react";
import { useTheme } from "react-jss";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import moment from "helpers/moment";
import parse from "html-react-parser";

/* Helpers, constants, custom methods, internal libraries */
import { useAirlineProgramsService } from "../../services/airlineProgramsService.js";
import { useLocaleContext } from "../../contexts/localeContext";
import { DELTA_HOME_LINK } from "../../constants/appConstants";

/* Components */
import UCButton from "../../components/buttons";
import DeltaImageOne from "../../resources/images/deltaThDesk.png";
import DeltaImageTwo from "../../resources/images/deltaThMobile.png";
import CarouselImage1 from "../../resources/images/deltaCarousel1.png";
import CarouselImage5 from "../../resources/images/deltaMobileCaro.png";
import ProgramCarouselModal from "../modals/programCarouselModal";
import { AIRLINEPROGRAMS_DELTAAIRLINESPROGRAM_ROUTE } from "../../constants/routes.js"

/* Styles */
import styles from "./styles.js";

const DLProgramContent = ({ delinkDeltaAirlines, deltaAirlinesSupplier, joinDeltaAirlines }) => {

    const theme = useTheme();
    const classes = styles({ theme });
    const { getStaticContent, staticContent } = useAirlineProgramsService();
    const locale = useLocaleContext();

    const [showProgramCarousel, setShowProgramCarousel] = useState(false);
    const [showFullText, setShowFullText] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const formatDate = (dateString) => {
        return moment(dateString).locale(locale).format("D MMM 'YY");
    };

    useEffect(() => {
        if (!staticContent || !staticContent?.deltaAirlines) {
            getStaticContent();
        }
    }, [staticContent]);

    const handleShow = (index) => {
        setCurrentIndex(index);
        setShowProgramCarousel(true);
    };

    const handleSelect = (selectedIndex) => {
        setCurrentIndex(selectedIndex);
    };

    const images = [
        CarouselImage1, CarouselImage5,
    ];

    const toggleText = () => {
        setShowFullText((prev) => !prev);
    };

    const staticContentUnavailable = Object.keys(staticContent).length === 0;
    const dlContentUnavailable = staticContent?.deltaAirlines?.headerText === "" || staticContent?.deltaAirlines?.text === ""

    const fullText = staticContent?.deltaAirlines?.text || ""
    const maxVisibleChars = 490;

    let buttonInjected = false;

    const renderFormattedText = (text, truncate = false) => {
        const paragraphs = text.split("\n\n");
        let accumulatedLength = 0;
        let isTruncated = false;

        return paragraphs.map((paragraph, idx) => {
            const parsedParagraph = parse(paragraph);

            if (truncate && !isTruncated) {
                const remainingChars = maxVisibleChars - accumulatedLength;

                if (accumulatedLength + paragraph.length > maxVisibleChars) {
                    const truncatedContent = paragraph.slice(0, remainingChars) + "...";
                    isTruncated = true;

                    const truncatedParsedParagraph = parse(truncatedContent);

                    if (truncatedParsedParagraph.type === "ul") {
                        return (
                            <div key={idx} className={classes.customContentTextParagraph}>
                                {injectButtonInList(truncatedParsedParagraph)}
                            </div>
                        );
                    }

                    return (
                        <div key={idx} className={classes.customContentTextParagraph}>
                            {truncatedParsedParagraph}
                        </div>
                    );
                }
            }

            accumulatedLength += paragraph.length;
            return (
                <div
                    key={idx}
                    className={
                        idx === paragraphs.length - 1
                            ? classes.customContentTextLastParagraph
                            : classes.customContentTextParagraph
                    }
                >
                    {injectButtonInList(parsedParagraph)}
                </div>
            );
        });
    };

    const injectButtonInList = (element) => {
        if (!element || element.type !== "ul" || buttonInjected) {
            return element;
        }

        const children = React.Children.toArray(element.props.children);

        if (children.length > 0) {
            const lastChild = children[children.length - 1];

            if (lastChild.type === "li") {
                const newLastChild = React.cloneElement(lastChild, {
                    children: (
                        <>
                            {lastChild.props.children}
                            <button onClick={toggleText} className={classes.inlineReadMoreButton}>
                                <FormattedMessage id="airlineProgram.deltaAirlines.program.readMoreDots" />
                                <FormattedMessage id="airlineProgram.deltaAirlines.program.readMore" />
                            </button>
                        </>
                    ),
                });

                buttonInjected = true;
                return React.cloneElement(element, {
                    children: [...children.slice(0, -1), newLastChild],
                });
            }
        }

        return element;
    };

    return (
        <div className={classes.dlProgramContent}>
            <Col xs={12} className={classes.dividerContainer}>
                <hr className={classes.border} />
            </Col>
            {
                !staticContentUnavailable && !dlContentUnavailable && staticContent?.deltaAirlines ? (
            <Container className={classes.customContentContainer}>
                <div>
                    <div className={classes.customContentHeader}>
                        {staticContent?.deltaAirlines?.headerText}
                    </div>
                    <div className={classes.customContentText}>
                        {showFullText ? (
                            renderFormattedText(fullText)
                        ) : (
                            renderFormattedText(fullText.slice(0, maxVisibleChars), true)
                        )}

                        {!buttonInjected && (
                            <button onClick={toggleText} className={classes.inlineReadMoreButton}>
                                {showFullText ? (
                                    <FormattedMessage id="airlineProgram.deltaAirlines.program.readLess" />
                                ) : (
                                    <FormattedMessage id="airlineProgram.deltaAirlines.program.readMore" />
                                )}
                            </button>
                        )}
                    </div>
                </div>
            </Container>
            ) : null
            }
            <Container className={classes.dlProgramContainer}>
                <Row className={classes.dlProgramRowOne}>
                    <Col className={classes.programWebsiteContainer}>
                        <p className={classes.bookOnText}><FormattedMessage id="airlineProgram.deltaAirlines.program.bookOn" /></p>
                        <a href={DELTA_HOME_LINK} target="_blank" className={classes.programWebsiteText}><FormattedMessage id="airlineProgram.deltaAirlines.program.website" /></a>
                    </Col>
                    {deltaAirlinesSupplier && deltaAirlinesSupplier?.userStatus !== "ACTIVE" && (
                        <UCButton
                            onClick={() => window.location.href = AIRLINEPROGRAMS_DELTAAIRLINESPROGRAM_ROUTE}
                            type="primary"
                            className={classes.connectButton}
                            text={<FormattedMessage id="airlineProgram.deltaAirlines.program.connectAccountButton" />}
                        />
                    )}
                    {deltaAirlinesSupplier && deltaAirlinesSupplier?.userStatus === "ACTIVE" && (
                        <>
                            <Col xs={5}>
                                <p className={classes.accountConnectedText}><FormattedMessage id="airlineProgram.deltaAirlines.program.accountConnected" /></p>
                                <Row xs={12} className={classes.accountDetailsContainer}>
                                    <span className={classes.programAccountNumberText}>{deltaAirlinesSupplier?.membershipNumber}</span><span className={classes.programAccountConnectedDate}>{formatDate(deltaAirlinesSupplier?.dateLinked)}</span>
                                </Row>
                            </Col>
                            <Col className={classes.connectButtonContainer} xs={3}>
                                <UCButton
                                    onClick={() => delinkDeltaAirlines(deltaAirlinesSupplier?.providerEntityID)}
                                    type="link"
                                    className={classes.delinkButton}
                                    text={<FormattedMessage id="airlineProgram.deltaAirlines.program.disconnectAccountButton" />}
                                    loadingStateStyling={classes.loadingState}
                                    spinnerClassName={classes.delinkSpinner}
                                    spinner={{
                                        name: "delinkDeltaSpinner",
                                        size: 20,
                                    }}
                                />
                            </Col>
                        </>
                    )}
                </Row>
                <Row className={classes.dlProgramRowTwo}>
                    <Col xs={6}>
                        <Image
                            onClick={() => handleShow(0)}
                            src={DeltaImageOne} />
                    </Col>
                    <Col xs={6}>
                        <Image
                            onClick={() => handleShow(1)}
                            src={DeltaImageTwo} />
                    </Col>
                </Row>
                <Row className={classes.dlProgramRowThree}>
                    <Col xs={12}>
                        <Row className={classes.faqContainer}>
                            <p className={classes.faqTitleText}><FormattedMessage id="airlineProgram.deltaAirlines.program.whatDoINeed" /></p>
                            <p className={classes.faqDescriptionText}>
                                <FormattedMessage id="airlineProgram.deltaAirlines.program.whatDoINeedDescription" />
                                <strong><FormattedMessage
                                    id="airlineProgram.deltaAirlines.program.howItWorksLink" /></strong>
                            </p>
                        </Row>
                        <Row className={classes.faqContainer}>
                            <p className={classes.faqTitleText}><FormattedMessage id="airlineProgram.deltaAirlines.program.howItWorks" /></p>
                            <p className={classes.faqDescriptionText}>
                                <FormattedMessage id="airlineProgram.deltaAirlines.program.howItWorksDescription1" />
                                <strong><FormattedMessage id="airlineProgram.deltaAirlines.program.howItWorksDescriptionChoose" /></strong>
                                <FormattedMessage id="airlineProgram.deltaAirlines.program.howItWorksDescriptionOption" />
                            </p>
                            <p className={classes.faqDescriptionText2}><FormattedMessage id="airlineProgram.deltaAirlines.program.howItWorksDescription2" /></p>
                        </Row>
                    </Col>
                </Row>
            </Container>
            <ProgramCarouselModal
                show={showProgramCarousel}
                setShow={setShowProgramCarousel}
                providerAirline={"delta"}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
                handleSelect={handleSelect}
                images={images}
            />
        </div>
    );
};

export default DLProgramContent;
